"use client";

import classNames from "classnames";
import styles from "modules/home/home.module.scss";
import { isEmpty } from "util/lodash/isEmpty";

interface IProps {
  banner: any;
  onClick: (banner: any) => void;
  idx: number;
}
function RenderBannerItem({
  banner, onClick, idx,
}: IProps) {
  return (
    <div
      className={classNames(styles.banner, {
        pointer: !isEmpty(banner.url),
      })}
      onClick={() => {
        if (onClick) {
          onClick(banner);
        }
      }}
    >
      <picture>
        <source srcSet={banner.extraLarge} media="(min-width: 1400px)" />
        <source srcSet={banner.large} media="(min-width: 1024px)" />
        <source srcSet={banner.medium} media="(min-width: 768px)" />
        <img
          alt="banner"
          src={banner.small}
          loading={idx === 0 ? "eager" : "lazy"}
          fetchPriority={idx === 0 ? "high" : "auto"}
        />
      </picture>
    </div>
  );
}

export default RenderBannerItem;
